import Vue from 'vue'
import App from './index.vue'
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import "../../styles/index.css";
import store from "../../store";
import "../../icons";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
// import 'swiper/css/swiper.css'
//
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(ElementUI);
//注册全局过滤器
import * as filters from "../../common/filter";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
